module.exports = __webpack_public_path__ + "img/NuxtJS.013d92db.png";